module.exports = __webpack_public_path__ + "static/media/check.9b1dbb20.svg";